// const contractAddress = "0x34A213755eFca4952DE2BC35E308d1Ddc931e001" // nft
const contractAddress = "0x365881EF7B672CC5dFBF5d755B9Df9CEFdbAFC03" //nft mainnet
export default contractAddress